export default __webpack_public_path__ + "static/media/close.0ce08d81.svg";